import React, { useState, useEffect } from "react";
import Home from "../home/main";
import MaintainanceSection from "../maintenance/maintainance";
import ViewProfile from "../view-profile/profile";
import LeasesSection from "../lease/leases";
import Notification from "../notification/main";
import PersonalInfo from "../profile-complete/personal-information/personal-info";
import CompanyInfo from "../profile-complete/company-information/company-info";
import BankMain from "../profile-complete/bank-account/bank-info";
import BroadCast from "../broadcast/broadcastMain";
import DetailLeaseMain from "../lease/leaseDetail/main";
import { useNavigate } from "react-router-dom";
import DetailMain from "../maintenance/maintanance-detail/detailMain";
import CreateMaintainace from "../maintenance/create-maintainance/main";
import HelpSection from "../help-tutorial/help";
import BaseUrl from "../../../constants/BaseUrl";
import { useSelector } from "react-redux";
const RightSection = ({ activeComponent, setActiveComponent, showChatBot }) => {
  const navigate = useNavigate();
  const [showDetail, setShowDetail] = useState("");
  const [recordLeaseId, setLeaseRecordId] = useState();
  const [recordId, setRecordId] = useState();

  const handleShowProfile = (item) => {
    if (item === "Password") {
      navigate("/reset-password");
    } else {
      setActiveComponent(item);
    }
  };
  const { loginSuccess } = useSelector((state) => state.auth);

  const CheckCurrentShift = () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/support/checkCurrentActiveSession`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          showChatBot(true);
        } else {
          showChatBot(false);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      CheckCurrentShift();
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // Function to show the Home component
  const handleShowHome = () => {
    setActiveComponent("Home"); // Set activeComponent to "Home"
  };

  // If the activeComponent is "Notification", show the Notification component
  if (activeComponent === "Notifications") {
    return <Notification onBack={handleShowHome} />;
  }

  const handleShowProfiles = () => {
    setActiveComponent("Profile");
  };

  const handleShowMaintainance = () => {
    setActiveComponent("Maintenance");
  };

  const handleShow = (item) => {
    setActiveComponent(item);
  };

  const toggleLeaseDetail = (status, id) => {
    setShowDetail(status);
    setLeaseRecordId(id);
    setActiveComponent("detailLease"); // State toggle karein
  };

  const toggleDetailMaintain = () => {
    setActiveComponent("MaintainanceDetails");
  };

  const handleShowBroadCast = () => {
    setActiveComponent("Broadcasts");
  };

  const handleLeaseTable = () => {
    setActiveComponent("Leases");
  };

  // Show the HomeSection component if activeComponent is "Home"
  if (activeComponent === "Home") {
    return (
      <Home
        onViewDetails={toggleLeaseDetail}
        onViewMaintainDetails={(item) => {
          setRecordId(item);
          toggleDetailMaintain();
        }}
        broadCastPage={handleShowBroadCast}
      />
    );
  }

  // Handle other sections
  if (activeComponent === "Maintenance") return <MaintainanceSection />;
  if (activeComponent === "Leases")
    return (
      <LeasesSection
        handleMaintainDetail={(item) => {
          setRecordId(item);
          toggleDetailMaintain();
        }}
        onMaintainanceTable={handleShowMaintainance}
        onTriggerCard={(item) => {
          handleShow(item);
        }}
      />
    );
  if (activeComponent === "Profile")
    return (
      <ViewProfile
        onBack={handleShowHome}
        onTriggerCard={(item) => {
          handleShowProfile(item);
        }}
      />
    );
  if (activeComponent === "General Info")
    return <PersonalInfo clases="mt-5" onBack={handleShowProfiles} />;
  if (activeComponent === "Create Maintenance")
    return <CreateMaintainace onBack={handleShowHome} />;
  if (activeComponent === "Business Information")
    return <CompanyInfo onBack={handleShowProfiles} />;
  if (activeComponent === "Payment Info")
    return <BankMain onBack={handleShowProfiles} />;
  if (activeComponent === "Help") return <HelpSection />;
  if (activeComponent === "Broadcasts") return <BroadCast />;
  if (activeComponent === "MaintainanceDetails")
    return <DetailMain recordId={recordId._id} onBack={handleShowHome} />;
  if (activeComponent === "detailLease")
    return (
      <DetailLeaseMain
        onBack={handleShowHome}
        showDetailStatus={showDetail}
        recordId={recordLeaseId}
        onViewDetailsMaintain={(item) => {
          setRecordId(item);
          toggleDetailMaintain(item);
        }}
        onMaintainancePage={handleShowMaintainance}
        onTriggerCard={(item) => {
          handleShow(item);
        }}
      />
    );

  return null; // Default case (if no activeComponent matches)
};

export default RightSection;
